export const CHAIN_ID = "columbus-5"
export const GAS_PRICE = "28.325"
export const DENOM = 'uluna'
export const MULTIPLIER = 2
export const TAX = 0.005
export const RPC_URL = "https://rpc-columbus-5.garuda-defi.org"

export const WC_PROJECT_ID = "90bd29bd5f8f1cf682ab8d4b07e8ff4d"
export const WALLET_ID_KEY = "WALLET_ID"
export const WALLET_TYPE_KEY = "WALLET_TYPE"
export const FACTORY_ADDRESS = "terra14kfx32ng7p8rrfdrnnmy3t48xlh2j0fgvrepp2y64j3k7hk2k9dqa44cs8"